import { render, staticRenderFns } from "./BigCrunchAutobuyerBox.vue?vue&type=template&id=d66a5b9a&scoped=true&"
import script from "./BigCrunchAutobuyerBox.vue?vue&type=script&lang=js&"
export * from "./BigCrunchAutobuyerBox.vue?vue&type=script&lang=js&"
import style0 from "./BigCrunchAutobuyerBox.vue?vue&type=style&index=0&id=d66a5b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66a5b9a",
  null
  
)

export default component.exports